import format from "./format";
export default {
  getFormatterTip1TimeDetail(date){
    let time = format.formatterDate5(date);
    let day = format.formatterDate4(date.getTime() / 1000);
    return day + '  ' + time[0] + ':' + time[1] + '<br>';
  },
  SGFormat(e, context){
    const icon = " <div style='background: #2cd200;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    const icon1 = " <div style='background: #e6be00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    const icon2 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    const icon3 = " <div style='background: #a4a4a4;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    const icon4 = " <div style='background: #ff5c5c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    const unit = (context.isMg) ? 'mg/dL' : 'mmol/L ';
    let type = e.value[2], tip0 = '';
    let value = e.value[1];
    if (value > 0) {
      let value1 = '', ico = icon;
      let isHighLow = true;
      try {
        //console.log('monitor sg tip:', value, typeof(value));
        let sg_val = parseFloat(value);
        if (context.isMg) {
          if (sg_val >= 400) {
            value = 'High';
          } else if (sg_val <= 40) {
            value = 'Low';
          } else {
            isHighLow = false;
          }
        } else {
          if (sg_val >= 22.2) {
            value = 'High';
          } else if (sg_val <= 2.2) {
            value = 'Low';
          } else {
            isHighLow = false;
          }
        }
        //console.log('monitor sg tip:', value, isHighLow);
      } catch (e) {
        console.log('sg tip:', e)
      }

      if (type === 'CX' || type === 'NC') {
        let hr1 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:45px;top: 45px;position: absolute">';
        let hr2 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:70px;top: 45px;position: absolute">';
        let hr3 = '<hr style="width: 25px;background:#FFF;height:1px;border:none;left:140px;top: 45px;position: absolute">';
        value1 = (context.isEn) ? value + hr1 : value + hr2;
        if (context.isFr) {
          value1 = value + hr3;
        }
      } else {
        value1 = value;
      }
      // daliy是DataS,daybyday是DataD
      const selectData = context.DataS?context.DataS:context.DataD
      if (context.isMg) {
        ico = (value > selectData.blos_high * 18) ? icon1 : ico;
        ico = (value < selectData.blos_low * 18) ? icon2 : ico;
      } else {
        ico = (value > selectData.blos_high) ? icon1 : ico;
        ico = (value < selectData.blos_low) ? icon2 : ico;
      }

      if (isHighLow) {
        tip0 = ico + context.$t('SG') + ' : ' + value1;
      } else {
        tip0 = ico + context.$t('SG') + ' : ' + value1 + unit;
      }

    }
    else {
      let ico = icon4, text = '';
      if (type === 'NC') { text = context.$t('Not Calibrated'); }
      if (type === 'DE') { text = context.$t('noReadings'); }
      if (type === 'CE0' || type === 'CE1') { text = context.$t('Calibration Error'); }
      if (type === 'H') { ico = icon3; text = context.$t('warm'); }
      tip0 = ico + text;
    }
    return tip0;
  },
  calibFormat(e, context){
    const unit = (context.isMg) ? 'mg/dL' : 'mmol/L ';
    const value = e.value[1];
    const icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon5 + context.$t('calib') + ' : ' + value + unit;
  },
  bgFormat(e, context){
    const unit = (context.isMg) ? 'mg/dL' : 'mmol/L ';
    const value = e.value[1];
    const icon5 = " <div style='background: #f00;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon5 + context.$t('BG Reading') + ' : ' + value + unit;
  },
  transmtrFormat(e, context){
    const icon5 = " <div style='background: #00a107;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon5 + context.$t('newSen');
  },
  alarmFormat(e, context){
    const icon5 = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
    return icon5 + context.$t('alert') + ' : ' + e.value[2];
  },
  basalFormat (value,name,context) {
    let basal_unit = 'U/H';
    try {
      basal_unit=context.$t('basal_unit2');
    }catch(e){

    }
    let transValue = Math.round(value[1] * 100) / 100;
    if (!transValue && transValue !== 0) {
      return 0/*通过判断是否连续来确定新数据是哪种类型*/
    } else {
      let icon = " <div style='background: #00ff4c;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
      return icon + name + ' :  ' + transValue + basal_unit
    }
  },
  autosuspendFormat (value) {
    let icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + value[2]
  },
  manualStopFormat (value, name) {
    let icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + name
  },
  normalBolusFormat (value,name,context) {
    let ins_unit2 = 'U';
    let t_suggest = 'Suggested';
    let t_adjustment = 'Adjustment';
    let t_N = 'N';
    let t_CN = 'CN';
    let t_Carb='Carb';
    let t_BG='BG';
    let t_Glucose='Glucose';
    let t_Active_Insulin='Active Insulin';

    try {
      ins_unit2=context.$t('ins_unit2');
      t_suggest = context.$t('t1102_Suggested');
      t_adjustment = context.$t('t1102_Adjustment');
      t_N = context.$t('N')
      t_CN = context.$t('CN1')
      t_Carb=context.$t('t1112_Carbs');
      t_BG=context.$t('t1112_BG');
      t_Glucose=context.$t('t1112_Glucose');
      t_Active_Insulin=context.$t('Active Insulin');
    }catch(e){

    }
    const normalSuggest = this.getSuggest(value[3])
    let icon = " <div style='background: #182f82;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let tmpTip = icon + name + ' :  ' + value[2] + ', ' + parseFloat(value[1]).toFixed(2) + ins_unit2;
    //tipArray[4] += '<br/>123()
    if ((value[2] === t_N || value[2] === t_CN)&&normalSuggest) {
      try {
        let wizzard_info = value[3];
        wizzard_info = JSON.parse(wizzard_info);
        let wizzard_carb = wizzard_info['carb'];
        let wizzard_bg = wizzard_info['bg'];
        let wizzard_iob = wizzard_info['iob'];
        let adjustmentType = wizzard_info['adjustmentType'];
        //
        let iobName = t_Active_Insulin+':';
        let BGName = t_BG+':';
        if (wizzard_bg) {
          if (context.isMg) {
            wizzard_bg = Math.round(wizzard_bg * 18) + ' mg/dL'
          } else {
            wizzard_bg = parseFloat(wizzard_bg).toFixed(1) + ' mmol/L'
          }
        }
        if (adjustmentType) {
          iobName = t_adjustment + ':';
          BGName = t_Glucose+':';
        } else {
          if (wizzard_iob > 100) {
            iobName = t_adjustment + ':';
            BGName = t_Glucose+':';
          }
          wizzard_iob = this.changeIob(wizzard_iob)
        }

        if (wizzard_carb && wizzard_bg) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb +':' + wizzard_carb + ' g, ' + BGName + wizzard_bg +
            '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' '+ins_unit2;
        } else if (wizzard_carb) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb +':' + wizzard_carb + ' g' +
            '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' '+ins_unit2;
        } else if (wizzard_bg) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + BGName + wizzard_bg +
            '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' '+ins_unit2;
        }
        if (normalSuggest) {
          tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_suggest +':' + normalSuggest + ' '+ins_unit2;
        }
      } catch (e) {
        console.log('出错啦： ', {value}, e)
      }
    }
    return tmpTip
  },
  extendBolusFormat (value,name,context) {
    let ins_unit2 = 'U';
    let t_suggest = 'Suggested';
    let t_adjustment = 'Adjustment';

    let t_Carb='Carb';
    let t_BG='BG';
    let t_Glucose='Glucose';
    let t_Active_Insulin='Active Insulin';

    try {
      ins_unit2=context.$t('ins_unit2');
      t_suggest = context.$t('t1102_Suggested');
      t_adjustment = context.$t('t1102_Adjustment');
      t_Carb=context.$t('t1112_Carbs');
      t_BG=context.$t('t1112_BG');
      t_Glucose=context.$t('t1112_Glucose');
      t_Active_Insulin=context.$t('Active Insulin');
    }catch(e){

    }
    let icon = " <div style='background: #f9b4ff;height: 8px;width: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    let tmpTip = icon + name + ' :  ' + value[4] + ', ' + parseFloat(value[2]).toFixed(2) + ins_unit2 + '/' + value[7] + 'min';
    try {
      let wizzard_info = value[5];
      wizzard_info = JSON.parse(wizzard_info);
      let wizzard_carb = wizzard_info['carb'];
      let wizzard_bg = wizzard_info['bg'];
      let wizzard_iob = wizzard_info['iob'];
      let adjustmentType = wizzard_info['adjustmentType'];
      //
      let iobName = t_Active_Insulin+':';
      let BGName = t_BG+':';
      if (wizzard_bg) {
        if (context.isMg) {
          wizzard_bg = Math.round(wizzard_bg * 18) + ' mg/dL'
        } else {
          wizzard_bg = parseFloat(wizzard_bg).toFixed(1) + ' mmol/L'
        }
      }

      if (adjustmentType) {
        iobName = t_adjustment+':';
        BGName = t_Glucose+':';
      } else {
        if (wizzard_iob > 100) {
          iobName = t_adjustment+':'
          BGName = t_Glucose+':';
        }
        wizzard_iob = this.changeIob(wizzard_iob)
      }

      if (wizzard_carb && wizzard_bg) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb +':' + wizzard_carb + ' g, ' + BGName + wizzard_bg +
          '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' '+ins_unit2;
      } else if (wizzard_carb) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_Carb +':' + wizzard_carb + ' g' +
          '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' '+ins_unit2;
      } else if (wizzard_bg) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + BGName + wizzard_bg +
          '<br/>&nbsp;&nbsp;&nbsp;' + iobName + parseFloat(wizzard_iob).toFixed(2) + ' '+ins_unit2;
      }
      let extendSuggest = this.getSuggest(wizzard_info)
      if (extendSuggest) {
        tmpTip += '<br/>&nbsp;&nbsp;&nbsp;' + t_suggest +':' + extendSuggest + ' '+ins_unit2;
      }

    } catch (e) {
      console.log('extend bolus tip:', e);
    }
    return tmpTip
  },
  newPatchFormat (value,name) {
    let icon = " <div style='background:yellowgreen;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + name
  },
  stopFormat (value,name) {
    let icon = " <div style='background: #ff0000;height: 8px;width: 8px;border-radius: 8px;margin-top:7px;margin-right: 4px;float: left;display: inline-block'></div>";
    return icon + name
  },
  alertFormat (value,name) {
    let icon = " <div style='height:0;width:0;margin-right:1px;border-width:6px;border-style:solid;border-color:transparent transparent #f00 transparent ;float:left;display: inline-block'></div>";
    return icon + name + ' :  ' + value[2]
  },
  autoModeBasalFormat (value,name,context) {
    let basal_unit = 'U/H';
    try {
      basal_unit=context.$t('basal_unit2');
    }catch(e){
    }
    value = Math.round(value[2] * 100) / 100;
    return name + ':' + value + basal_unit
  },
  autoModeCorrBolusFormat (value, name, context) {
    let t_auto_correction = 'Auto mode correction bolus';
    let t_auto_meal = 'Auto meal bolus';
    let ins_unit2 = 'U';
    try {
      t_auto_correction = context.$t('t1029_Auto_mode_correction_bolus');
      t_auto_meal = context.$t('t1029_Auto_meal_bolus');
      ins_unit2=context.$t('ins_unit2');
    }catch(e){
      console.log('t_auto_meal:', e)
    }
    let tmpTip = ''
    if (value[2]) {
      tmpTip += t_auto_meal + ':' + parseFloat(value[2]).toFixed(2) + ins_unit2;
    }
    if (value[1] && value[2]) {
      tmpTip += '<br/>' + t_auto_correction + ':' + parseFloat(value[1]).toFixed(2) + ins_unit2;
    } else if (value[1]) {
      tmpTip += t_auto_correction + ':' + parseFloat(value[1]).toFixed(2) + ins_unit2;
    }
    return tmpTip
  },
    /**
  * 计算建议值，传入信息为空、undefined、null、'{}'、{}返回0
  * @param {*} bolusInfo bolus信息
  * @returns
  */
  getSuggest (bolusInfo) {
    // 判断bolusInfo是否为空
    if (!bolusInfo || bolusInfo === '{}') return 0
    let bolusInfoJSON = undefined
    if (bolusInfo instanceof Object) {
      if (JSON.stringify(bolusInfo) === '{}') return 0
      bolusInfoJSON = bolusInfo
    } else {
      try {
        bolusInfoJSON = JSON.parse(bolusInfo)
      } catch (e) {
        console.log('错误json： ', bolusInfo)
        return 0
      }
    }

    /**
     * 数据格式有三种：新easypatch、老easypatch和pdm,区别如下
     * 数据格式     |  是否需要iob转换 | 是否有adjustment字段 | 是否需要调换bg_bolus |
     * 老easypatch  |       是         |      否              |         否          |
     * 新easypatch  |       否         |      是              |         否          |
     *      pdm     |       是         |      否              |         是          |
     *
     */
    let suggest = 0
    let data_source = sessionStorage.getItem('data_source');
    if (!data_source) return 0
    // 判断是否为pdm数据
    if (data_source === 'daoppdm') {
      // 如果同时有bg_bolus和carb_bolus才调换，否则将不存在的字段设为0，不进行调换
      if (undefined == bolusInfoJSON.carb_bolus) {
        bolusInfoJSON.carb_bolus = 0
      } else if (undefined == bolusInfoJSON.bg_bolus) {
        bolusInfoJSON.bg_bolus = 0
      } else {
        [bolusInfoJSON.bg_bolus, bolusInfoJSON.carb_bolus] = [bolusInfoJSON.carb_bolus, bolusInfoJSON.bg_bolus]
      }

      // 转换调换后的bg_bolus
      bolusInfoJSON['corr_bolus'] = this.change2SignedNumber(bolusInfoJSON.bg_bolus)
    } else {
      if (undefined == bolusInfoJSON.carb_bolus) {
        bolusInfoJSON.carb_bolus = 0
      } else if (undefined == bolusInfoJSON.corr_bolus) {
        bolusInfoJSON.corr_bolus = 0
      }
    }
    //console.log("bolusInfoJSON:", bolusInfoJSON);
    // 处理adjustmentType,且值不为1的情况，即新版本自动模式数据
    if (bolusInfoJSON['adjustmentType']) {
      suggest = bolusInfoJSON.corr_bolus + bolusInfoJSON.carb_bolus + bolusInfoJSON.iob
    } else if (bolusInfoJSON.iob > 100) {
      // bolusInfoJSON.iob > 100 表示是老版本自动模式数据
      bolusInfoJSON.iob = this.changeIob(bolusInfoJSON.iob)
      suggest = bolusInfoJSON.corr_bolus + bolusInfoJSON.carb_bolus + bolusInfoJSON.iob
    }
    // 以下为非自动模式算法
    else if (bolusInfoJSON.corr_bolus < 0) {
      suggest = bolusInfoJSON.carb_bolus + bolusInfoJSON.corr_bolus
    } else if (bolusInfoJSON.corr_bolus <= bolusInfoJSON.iob) {
      suggest = bolusInfoJSON.carb_bolus
    } else {
      suggest = bolusInfoJSON.carb_bolus + bolusInfoJSON.corr_bolus - bolusInfoJSON.iob
    }
    // 向上取整
    // suggest = Math.ceil(suggest/0.05)*5/100
    // console.log('bolusInfo, suggest: ', bolusInfoJSON,bolusInfo, suggest)
    return suggest.toFixed(2)
  },
  // 转换iob
  changeIob (UnSignedNumber) {
    if (UnSignedNumber > 100) {
      if (UnSignedNumber > 500) {
        let val = (Math.round(UnSignedNumber / 0.05) & 0x3fff)
        if (val > 0x1fff) {
          UnSignedNumber = (val - 0x4000) * 0.05
        } else if (val >= 0) {
          UnSignedNumber = (val) * 0.05
        }

      } else {
        let val = (Math.round(UnSignedNumber / 0.01) & 0x3fff);
        if (val > 0x1fff) {
          UnSignedNumber = (val - 0x4000) * 0.01
        } else if (val >= 0) {
          UnSignedNumber = (val) * 0.01;
        }
      }
    }
    return UnSignedNumber
  },
  // 16位无符号的数转换成有符号数
  change2SignedNumber (UnSignedNumber) {
    if (UnSignedNumber > 327.67) {
      let strNum = new Number(UnSignedNumber).toString();
      // 这里有bug, 如果是655.3的话会出错。
      let val = Math.round(UnSignedNumber*100);
      let max=655.36;
      if (val%5 == 0) {
       max=655.35;
      }
      return UnSignedNumber - max;
      // return UnSignedNumber - (655.36 - 0.01 * (strNum[strNum.length - 1] === '0' || strNum[strNum.length - 1] === '5'))
    }
    return UnSignedNumber
  }
}



// WEBPACK FOOTER //
// ./src/lib/chartTipFormat.js